var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66686 -6.79955e-08C6.52599 -3.04416e-08 7.22241 0.696446 7.22241 1.55556L7.22241 12.4444C7.22241 13.3036 6.52599 14 5.66686 14L4.1113 14C3.25217 14 2.55574 13.3036 2.55574 12.4444L2.55575 1.55556C2.55575 0.696445 3.25217 -1.73545e-07 4.1113 -1.35991e-07L5.66686 -6.79955e-08Z",
    fill: "#172B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55572 -3.39977e-08C9.98527 -1.52215e-08 10.3335 0.348227 10.3335 0.777778L10.3335 13.2222C10.3335 13.6518 9.98527 14 9.55572 14C9.12615 14 8.77794 13.6518 8.77794 13.2222L8.77794 0.777778C8.77794 0.348227 9.12615 -5.27747e-08 9.55572 -3.39977e-08Z",
    fill: "#172B4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6666 -3.39977e-08C13.0961 -1.52215e-08 13.4443 0.348227 13.4443 0.777778L13.4443 13.2222C13.4443 13.6518 13.0961 14 12.6666 14C12.237 14 11.8888 13.6518 11.8888 13.2222L11.8888 0.777778C11.8888 0.348227 12.237 -5.2774e-08 12.6666 -3.39977e-08Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLs);
export default __webpack_public_path__ + "static/media/ls.ee48ed0f03c9891bae62e51383f019c5.svg";
export { ForwardRef as ReactComponent };